import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import axios from 'axios';

// Configure axios to send cookies with requests
axios.defaults.withCredentials = false;  // Cần true vì nginx đang set credentials=true

// Set base URL for API calls
axios.defaults.baseURL = 'https://apitiktok.taothaoai.com';

// Token refresh is now handled in AuthContext

// Global error handler
window.addEventListener('error', (event) => {
  console.error('🚨 Global Error:', event.error);
  console.error('🚨 Error details:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno
  });
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('🚨 Unhandled Promise Rejection:', event.reason);
  console.error('🚨 Promise:', event.promise);
});

// Axios interceptor for API errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('🚨 API Error:', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      message: error.message,
      data: error.response?.data
    });
    
    // Handle token expiration
    if (error.response?.status === 401) {
      console.error('🚨 Token expired or invalid');
      localStorage.removeItem('token');
      delete axios.defaults.headers.common['Authorization'];
      // Redirect to login if not already there
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);